module.exports = __webpack_public_path__ + "static/media/testimonial.492c5e35.png";